import { render, staticRenderFns } from "./AudioNoticeboardNumbers.vue?vue&type=template&id=02ea2888&"
import script from "./AudioNoticeboardNumbers.vue?vue&type=script&lang=js&"
export * from "./AudioNoticeboardNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QInput});
